import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", { style: {"color":"black"} }, "Openstaande servicemeldingen", -1)

import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { LoadingOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueWidget',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const issues = ref({
  open: 0,
  new: 0,
  almostOverdue: 0,
  overdue: 0
})

onMounted(() => {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/issues/personal/overview').then((r) => {
    issues.value = r.data
  }).finally(() => {
    loading.value = false
  })
})

return (_ctx: any,_cache: any) => {
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { gutter: [16,16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 6},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Issues' })))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { loading: loading.value }, {
              default: _withCtx(() => [
                _createVNode(_component_a_statistic, {
                  style: { cursor: 'pointer' },
                  value: issues.value.open,
                  "value-style": { fontWeight: 'bold' }
                }, {
                  title: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16,16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 6}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              style: {"width":"100%"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'Issues' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Direct naar servicemeldingen ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})